import { getLoanById } from '@nemuru-eng/js-api-client';
import { useEffect, useLayoutEffect } from 'react';
import { useParams } from 'react-router-dom';

import { usePageContext } from '@/contexts/PageContext/PageContext';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { findCurrentParticipantOnboardingDetailsByOnboardingDetailsId } from '@/utils/findCurrentParticipantOnboardingDetails';

export const LoanPageManager = () => {
  const {
    state: { loading, applicationParticipant },
    actions: pageActions,
  } = usePageContext();

  const { loanId } = useParams();

  if (!loanId) return null;

  const { data: loan, loading: getLoanByIdLoading } = useCache(getLoanById, { loanId }, { fallbackData: null });

  const participantOnBoardingDetails = findCurrentParticipantOnboardingDetailsByOnboardingDetailsId({
    loan,
    onboardingDetailsId: applicationParticipant.onboardingDetails?.id,
  });

  const participantFirstName = participantOnBoardingDetails?.invitation.fullName.firstName;
  const participantLastName = participantOnBoardingDetails?.invitation.fullName.lastName;
  const title = loan ? `${participantFirstName} ${participantLastName} ` : '';
  const subtitle = applicationParticipant.role;
  useSetPageLoadingWhenRequesting('LOAN_DETAILS', [getLoanByIdLoading]);

  useEffect(() => {
    if (loan === null && getLoanByIdLoading === false) {
      pageActions.setNotFound(true);
    }
  }, [getLoanByIdLoading]);

  useLayoutEffect(() => {
    pageActions.setCustomTitle(title);
    pageActions.setCustomSubtitle(subtitle);
  }, [title, subtitle, loading]);

  return <> </>;
};
